import { makeRequest } from 'utils/requestLogger';
// import config from '../apiConfigs';

export default (files) => {
  const formData = new FormData();
  formData.append('file', files[0]);

  return makeRequest('post', '/api/files', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};



// WEBPACK FOOTER //
// ./src/app/services/account/uploadFile.js